import { Component, ErrorInfo, ReactNode } from 'react';
import { IMPRESSIONS } from '../constants/metrics';

import metricsService from '../services/metrics';
import { rumService } from '../services/rum';
import logger from '../utils/logger';

class ErrorLogger extends Component<{
  boundaryIdentifier: string;
  children?: ReactNode;
}> {
  public state = {
    hasError: false,
    error: null,
  };

  static getDerivedStateFromError(error: Error | null) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const errorType = 'RenderError';
    const urlParams = new URLSearchParams(window.location.search);
    const clientId = urlParams.get('client_id');

    const metricsPublisher = metricsService.getPublisher(errorType);
    metricsPublisher.publishCounterMonitor(IMPRESSIONS, 1);
    metricsPublisher.publishCounterMonitor(this.props.boundaryIdentifier, 1);

    // The RUM client has no way to supply custom fields when recording an error.
    // As we need a way to quickly distinguish render blocking errors from standard
    // javascript errors, we log a separate event with additional details.
    rumService.recordEvent(errorType, {
      boundaryId: this.props.boundaryIdentifier,
      clientId: clientId,
      message: error.message,
    });
    rumService.recordError(error);

    logger.error(errorType, error, errorInfo);
    throw error;
  }

  render() {
    return this.state.hasError ? <></> : this.props.children;
  }
}

export default ErrorLogger;
